import colorPalette from '../color-palette';

const { info } = colorPalette;

export default {
  MuiAlert: {
    standardInfo: {
      backgroundColor: info.light,
      alignItems: 'center',
    },
  },
};
